import React from 'react';
import { addModule, addReducers } from '../connector';
import Home from './Home';
// import {Icon} from 'common/components'
export const ROOT = '/category';
export const MODULE = 'CATEGORY';


// addReducers({ admins: reducers });
addModule(
    { path: `${ROOT}`, component: Home, icon: 'laptop-code', title: "Category", exact: 0, hideNav: 0 },
)
